import { render, staticRenderFns } from "./ChooseTable.vue?vue&type=template&id=49682460&scoped=true&"
import script from "./ChooseTable.vue?vue&type=script&lang=js&"
export * from "./ChooseTable.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTable.vue?vue&type=style&index=0&id=49682460&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49682460",
  null
  
)

export default component.exports